import { useEffect, useRef } from 'react'

import { createStyles } from 'antd-style'
import { isNil } from 'lodash'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'

import { system } from '../../../config/system'
import { getApiHint } from '../../../store/application/helpers/util'
import { init } from '../sdk/index'
import { IAppConfig, IWps } from '../sdk/interface'
import { useWebOfficeStore } from '../Store/hooks/useStore'

import { WebOfficeEditorProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  container: {
    height: '100%',
    width: '100%'
  }
}))

export const WebOfficeEditor = ({
  className,
  style,
  fileId,
  officeType,
  readOnly,
  download,
  comment,
  copy,
  history,
  print,
  saveAs,
  commonOptions,
  commandBars,
  onFileNameChange
}: WebOfficeEditorProps) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const setInstance = useWebOfficeStore(state => state.setInstance)

  // 访问 hint 指定的服务
  const hint = getApiHint()

  const customArgs = {
    update: isNil(readOnly) ? '' : !readOnly,
    download: download ?? '',
    comment: comment ?? '',
    copy: copy ?? '',
    history: history ?? '',
    print: print ?? '',
    saveAs: saveAs ?? '',
    [hint.key]: hint.value,
    // weboffice 后台应用中配置的回调地址为代理服务地址，这里把真正的后端服务地址传给代理服务地址进行转发
    originalServer: system.webOffice.serverUrl
  }

  const mode = readOnly ? 'simple' : 'nomal'

  const token = useAuthStore(state => state.tokenInfo.tokenValue)

  useEffect(() => {
    const instance = init({
      mount: containerRef.current,
      appId: system.webOffice.appId,
      fileId,
      officeType,
      token,
      mode,
      customArgs,
      commandBars: [
        {
          cmbId: 'ContextMenuConvene',
          attributes: {
            visible: false
          }
        },
        {
          cmbId: 'BookMarkContextMenu',
          attributes: {
            visible: false
          }
        },
        ...(commandBars ?? [])
      ],
      commonOptions: {
        isShowTopArea: true,
        isShowHeader: true,
        /* 开启后会导致 iframe 无法全屏，https://solution.wps.cn/docs/web/events.html#fullscreenchange */
        isBrowserViewFullscreen: false,
        isIframeViewFullscreen: false,
        /* ----------------------------------- END ---------------------------------- */
        acceptVisualViewportResizeEvent: true,
        ...commonOptions
      }
    } as IAppConfig) as IWps

    if (!instance) {
      throw new Error('WebOffice instance is not initialized')
    }

    ;(async () => {
      await instance.ready()
      // TODO: not working
      // await instance.Application.ActiveDocument.SetContentControlAuthority(
      //   'read'
      // )
      setInstance(instance)
    })()

    return () => {
      instance.destroy()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileId, officeType])

  const { cx, styles } = useStyles()

  return (
    <div
      ref={containerRef}
      className={cx(styles.container, className)}
      style={style}
    />
  )
}
